import { Component, OnInit, Renderer2, Output, EventEmitter } from '@angular/core';
import templateString from './allocationRequestAccumulationTypeForm.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AllocationRequestAccumulationType } from '../../../models/allocationRequestAccumulationType.model';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString
})
export class AllocationRequestAccumulationTypeFormComponent implements OnInit {
    @Output() action = new EventEmitter();
	
	public allocationRequestAccumulationTypeId: any;

	public allocationRequestAccumulationType: any;
	public submitted: boolean;	
	public actionTitle: string;
	public isLoading: boolean;

    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2,
        private toastr: ToastrService
	) {
		this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
	}

  	ok(isValid) {
		this.submitted = true;
		
		if (isValid) {
			if (this.allocationRequestAccumulationTypeId === null) {
				this.http.post("allocation_request_accumulation_types", this.allocationRequestAccumulationType).subscribe(() => {
					this.action.emit(true);
					this.bsModalRef.hide();
				}, (response) => {
					this.toastr.error(response.error.error);
				});
			} else {
				this.http.put("allocation_request_accumulation_types/" + this.allocationRequestAccumulationType.id, this.allocationRequestAccumulationType).subscribe(() => {
					this.action.emit(true);
					this.bsModalRef.hide();
				}, (response) => {
					this.toastr.error(response.error.error);
				});
			}
		}
  	}

  	cancel() {
		this.bsModalRef.hide();
  	}

    ngOnInit() {
		if (this.allocationRequestAccumulationTypeId === null) {
			this.actionTitle = "toevoegen";
			this.allocationRequestAccumulationType = new AllocationRequestAccumulationType();
		} else {
			this.actionTitle = "wijzigen";
			this.http.get("allocation_request_accumulation_types/" + this.allocationRequestAccumulationTypeId).subscribe(x => {
				this.allocationRequestAccumulationType = x;
			});
		}
    }
}
